var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "todaycourse-page-main" }, [
    _c(
      "div",
      { staticClass: "search search-div" },
      [
        _c("van-search", {
          attrs: { shape: "round", placeholder: "请输入搜索关键词" },
          on: { input: _vm.search },
          model: {
            value: _vm.keywords,
            callback: function ($$v) {
              _vm.keywords = $$v
            },
            expression: "keywords",
          },
        }),
      ],
      1
    ),
    _c("div", { staticClass: "date-div" }, [
      _c("div", { staticClass: "icon-button", on: { click: _vm.reduce } }, [
        _c("span", { staticClass: "iconfont icon-shangyibu" }),
      ]),
      _c("div", { staticClass: "day-title" }, [_vm._v(_vm._s(_vm.dayName))]),
      _c("div", { staticClass: "icon-button", on: { click: _vm.add } }, [
        _c("span", { staticClass: "iconfont icon-xiayibu" }),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "todaycourse-scroll-box" },
      [
        _c("teas-today-course-list", {
          attrs: { url: _vm.urlOfflineShift, "is-design": _vm.isDesign },
          on: { itemClick: _vm.itemClick },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }